import { render, staticRenderFns } from "./SeriesAvailableFundsToBeAdded.vue?vue&type=template&id=0b37de04&scoped=true&"
import script from "./SeriesAvailableFundsToBeAdded.vue?vue&type=script&lang=js&"
export * from "./SeriesAvailableFundsToBeAdded.vue?vue&type=script&lang=js&"
import style0 from "./SeriesAvailableFundsToBeAdded.vue?vue&type=style&index=0&id=0b37de04&lang=scss&scoped=true&"
import style1 from "./SeriesAvailableFundsToBeAdded.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0b37de04",
  null
  
)

export default component.exports